import { render } from "./ServicePage.vue?vue&type=template&id=9ea844dc&scoped=true"
import script from "./ServicePage.vue?vue&type=script&lang=js"
export * from "./ServicePage.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-9ea844dc"

export default script